import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LayoutService } from './service/app.layout.service';
import { InMemoryCacheService } from '../common';
import { BillingService } from '../pages/billing/billing.service';
import { AppMenuComponent } from './app.menu.component';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, AppMenuComponent],
    templateUrl: './app.sidebar.component.html',
    styles: [`
        .app-logo {
            cursor: pointer;
        }
    `]
})
export class AppSidebarComponent {
    timeout: any = null;

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    constructor(public layoutService: LayoutService, public el: ElementRef, private router: Router,
        private billingService: BillingService, private cache: InMemoryCacheService) {}


    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;


        }
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => this.layoutService.state.sidebarActive = false, 300);
            }
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }

    async onLogoClicked() {
        this.cache.loading = true;
        const { data } = await this.billingService.getUserByUserId(this.cache?.user?.id);
        this.cache.loading = false;
        this.cache.user  = data;
        this.router.navigate(['/']);
    }

}
